import { HeaderCellProps } from '../../types';
import { Tooltip } from '@mui/material';

const TotalPersistingHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return (
    <Tooltip title="Number of entities, uploaded before 12 am today, stuck in the pending state">
      <div>Total Persisting</div>
    </Tooltip>
  );
};

export default TotalPersistingHeaderCell;
